<div class="grid container">
  <div class="col-6">
    <div class="grid">
      <div class="col-4"><label for="colName">Name der Spalte</label></div>
      <div class="col-8"><input #colName type="text" pInputText [(ngModel)]="availableColumnToView.colName" class="textinput" /></div>
    </div>
    <div class="grid">
      <div class="col-4"><label for="colDesc">Beschreibung</label></div>
      <div class="col-8"><textarea id="colDesc" pTextarea [(ngModel)]="availableColumnToView.colDesc" class="textinput"></textarea></div>
    </div>
    <div class="grid">
      <div class="col-4"><label for="colType">Spaltentyp</label></div>
      <div class="col-8"><p-select appendTo="body" (onChange)="changeListenTyp($event)"  [options]="colTypeOptions" [(ngModel)]="availableColumnToView.colType" class="textinput"></p-select></div>
    </div>
    <div class="grid">
      <div class="col-4"><label for="dbMapping">Db-Mapping</label></div>
      <div class="col-8">
        <p-select [options]="settingValueList()"  [(ngModel)]="selecteddbMapping" appendTo="body" styleClass="w-full"
          showClear="true" (onClear)="clearDbMapping()"
          dataKey="settingValue"
          optionLabel="settingValue"
        (onChange)="changeDbMapping($event)" ></p-select>
      </div>
    </div>
    <div class="grid">
      <div class="col-4"><label for="bubMapping">BuB-Mapping</label></div>
      <div class="col-8"><input #bubMapping type="text" pInputText [(ngModel)]="availableColumnToView.bubMapping" class="textinput" /></div>
    </div>
    <div class="grid">
      <div class="col-4"><label for="isSystem">Systemfeld</label></div>
      <div class="col-8"><p-checkbox #isSystem [(ngModel)]="availableColumnToView.systemColumn" binary="true" class="textinput"></p-checkbox></div>
    </div>
    <div class="grid">
      <div class="col-4"></div>
      <div class="col-8">@if (hint()) {
        <p-message  styleClass="w-full" severity="warn"  [text]="hint() ">  </p-message>
      }
    </div>
  </div>
</div>

@if (availableColumnToView) {
  <div class="col-6">
    <div class="grid">
      <div class="col-12">
        <h6 style="padding-left: 15px;">Vorgaben für die Validierung</h6>
      </div>
    </div>
    @if (availableColumnToView.colType == colEnum.Text) {
      <div>
        <div class="grid">
          <div class="col-6"><label for="minLength" style="padding-left: 15px;">Minimale Länge</label></div>
          <div class="col-6"><p-inputnumber id="minLength" [(ngModel)]="textValue.minlength" [step]="1"  thousandSeparator="." decimalSeparator="," [size]="8"></p-inputnumber></div>
        </div>
        <div class="grid">
          <div class="col-6"><label for="maxLength" style="padding-left: 15px;">Maximale Länge</label></div>
          <div class="col-6"><p-inputnumber #maxLength [(ngModel)]="textValue.maxlength" [step]="1"  thousandSeparator="." decimalSeparator="," [size]="8"></p-inputnumber></div>
        </div>
        <div class="grid">
          <div class="col-6"><label for="regEx" style="padding-left: 15px;">Erlaubte Werte</label></div>
          <div class="col-6"><input #regEx type="text" [(ngModel)]="textValue.validregex" pInputText style="padding-right: 15px;" /></div>
        </div>
        <div class="grid">
          <div class="col-6"><label style="margin-left: 15px;" for="dynlistreference">Prüfen auf Inhalt von</label></div>
          <div class="col-6"><p-select  optionLabel="label" id="dynlistreference" [style]="{'width': '100%'}"   appendTo="body"
            optionValue="value" showClear="true"
          [options]="referenceColumnValueNumberListOptions()" [(ngModel)]="textValue.requiredcolumnvalue" class="textinput"></p-select></div>
        </div>
        <div class="grid">
          <div class="col-6"><label style="margin-left: 15px;" for="dynlistreferenceleer">Prüfen auf Inhalt ist NICHT gesetzt</label></div>
          <div class="col-6"><p-multiselect  optionLabel="label" id="dynlistreference" [style]="{'width': '100%'}"   appendTo="body"
            optionValue="value" showClear="true"
          [options]="referenceNOTColumnValueNumberListOptions()" [(ngModel)]="textValue.notcolumnvalue" class="textinput"></p-multiselect></div>
        </div>
      </div>
    }
    @if (availableColumnToView.colType == colEnum.Number) {
      <div>
        <div class="grid">
          <div class="col-6"><label for="numberMin" style="padding-left: 15px;">Stellen</label></div>
          <div class="col-6"><p-inputnumber  #numberMin [step]="1" [(ngModel)]="numberValue.maxdigits" min="0"   thousandSeparator="." decimalSeparator="," [size]="8"></p-inputnumber></div>
        </div>
        <div class="grid">
          <div class="col-6"><label for="numberMax"  style="padding-left: 15px;">Nachkommastellen</label></div>
          <div class="col-6"><p-inputnumber #numberMax [step]="1" [(ngModel)]="numberValue.maxdecimals"  min="0" max="9" thousandSeparator="." decimalSeparator="," [size]="8"></p-inputnumber></div>
        </div>
        <div class="grid">
          <div class="col-6"><label for="isNumberOnly" style="padding-left: 15px;">Ganzzahlen</label></div>
          <div class="col-6"><p-checkbox binary="true" [(ngModel)]="numberValue.isnumberonly"></p-checkbox> </div>
        </div>
        <div class="grid ">
          <div class="col-6"><label for="minnumber" style="padding-left: 15px;">Min / Max Wert</label></div>
          <div class="col-2"><p-inputnumber inputStyleClass="max-w-10rem" class="max-w-10rem" styleClass="max-w-10rem"  placeholder="Minimaler Wert" id="minnumber" [(ngModel)]="numberValue.minNumber" [step]="1"  [size]="8"></p-inputnumber></div>
          <div class="col-1"></div>
          <div class="col-2"><p-inputnumber inputStyleClass="max-w-10rem" class="max-w-10rem" styleClass="max-w-10rem" placeholder="Maximaler Wert" #maxLength [(ngModel)]="numberValue.maxNumber" [step]="1"  thousandSeparator="." decimalSeparator="," [size]="8"></p-inputnumber></div>
          <div class="col-1"></div>
        </div>
        <div class="grid">
          <div class="col-6"><label style="margin-left: 15px;" for="dynlistreference">Prüfen auf Inhalt von</label></div>
          <div class="col-6"><p-select  optionLabel="label" id="dynlistreference" [style]="{'width': '100%'}"   appendTo="body"
            optionValue="value" showClear="true"
          [options]="referenceColumnValueNumberListOptions()" [(ngModel)]="numberValue.requiredcolumnvalue" class="textinput"></p-select></div>
        </div>
        <div class="grid">
          <div class="col-6"><label style="margin-left: 15px;" for="dynlistreferenceleer">Prüfen auf Inhalt ist NICHT gesetzt</label></div>
          <div class="col-6"><p-multiselect  optionLabel="label" id="dynlistreference" [style]="{'width': '100%'}"   appendTo="body"
            optionValue="value" showClear="true"
          [options]="referenceNOTColumnValueNumberListOptions()" [(ngModel)]="numberValue.notcolumnvalue" class="textinput"></p-multiselect></div>
        </div>
      </div>
    }
    @if (availableColumnToView.colType == colEnum.DynamicList) {
      <div>
        <div class="grid">
          <div class="col-12"> <label style="margin-left: 15px;">  {{dynmlistValue && dynmlistValue?.value == 1 ? ' Möbelauswahl' : ''}}</label></div>
          <!-- <div class="col-4"><label for="dynlist">Dynamische Liste</label></div>
          <div class="col-8"><p-select  optionLabel="label" id="dynlist" [style]="{'width': '100%'}"   appendTo="body"  [options]="dynListOptions" [(ngModel)]="dynmlistValue" class="textinput"></p-select></div> -->
        </div>
        <div class="grid">
          <div class="col-6"  ><label style="margin-left: 15px;" for="dynlist">Prüfen auf Inhalt von</label></div>
          <div class="col-6"><p-select  optionLabel="label" id="dynlistreference" [style]="{'width': '100%'}"   appendTo="body"
            optionValue="value" showClear="true"
          [options]="referenceColumnValuesDynListOptions()" [(ngModel)]="referenceColumnValueDynList" class="textinput"></p-select></div>
        </div>
        <div class="grid">
          <div class="col-6"><label style="margin-left: 15px;" for="dynlistreferenceleer">Prüfen auf Inhalt ist NICHT gesetzt</label></div>
          <div class="col-6"><p-multiselect  optionLabel="label" id="dynlistreference" [style]="{'width': '100%'}"   appendTo="body"
            optionValue="value" showClear="true"
          [options]="referenceNOTColumnValueNumberListOptions()" [(ngModel)]="referenceNOTColumnValueDynList" class="textinput"></p-multiselect></div>
        </div>
      </div>
    }
    @if (availableColumnToView.colType == colEnum.List) {
      <div>
        <div class="grid">
          <div class="col-4" style="font-size:larger">
            Liste
          </div>
          <div class="col-8"></div>
        </div>
        <div class="grid">
          <div class="col-12" style="margin-bottom: 5px;">
            <button pButton type="button" icon="pi pi-plus" (click)="addNewListValue()" style="float: right;"></button>
          </div>
        </div>
        <div class="grid">
          <div class="col-12">
            <p-table [value]="listValue.valuelist" [rows]="5" editMode="cell" [paginator]="true">
              <ng-template pTemplate="header">
                <tr>
                  <th>Werte</th>
                  <th style="width: 4em;">&nbsp;</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-rowData>
                <tr>
                  <td pEditableColumn>
                    <p-cellEditor>
                      <ng-template pTemplate="input">
                        <input pInputText type="text" [(ngModel)]="rowData.item" />
                      </ng-template>
                      <ng-template pTemplate="output">
                        {{ rowData.item }}
                      </ng-template>
                    </p-cellEditor>
                  </td>
                  <td style="width: 4em;">
                    <button pButton type="button" icon="pi pi-trash" (click)="deleteListValue(rowData.item)"></button>
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
      </div>
    }
    @if (availableColumnToView.colType == colEnum.DateRange) {
      <div>
        <div class="grid">
          <div class="col-5"><label for="dateRangeStart" style="margin-left: 15px;">Startdatum</label></div>
          <div class="col-7"><p-datepicker #dateRangeStart [(ngModel)]="dateRangeValue.daterangestart" [showIcon]="true" [firstDayOfWeek]="1" dateFormat="dd.mm.yy"></p-datepicker></div>
        </div>
        <div class="grid">
          <div class="col-5"><label for="dateRangeEnd" style="margin-left: 15px;">Enddatum</label></div>
          <div class="col-7"><p-datepicker #dateRangeEnd [(ngModel)]="dateRangeValue.daterangeend" [showIcon]="true" [firstDayOfWeek]="1" dateFormat="dd.mm.yy"></p-datepicker></div>
        </div>
      </div>
    }
    @if (availableColumnToView.colType == colEnum.NumberRange) {
      <div>
        <div class="grid">
          <div class="col-6"><label for="numberRangeMin" style="padding-left: 15px;">Minimum</label></div>
          <div class="col-6"><p-inputnumber  #numberRangeMin [step]="0.1" [(ngModel)]="numberRangeValue.numberrangestart"  thousandSeparator="." decimalSeparator="," [size]="8"></p-inputnumber></div>
        </div>
        <div class="grid">
          <div class="col-6"><label for="numberRangeMax"  style="padding-left: 15px;">Maximum</label></div>
          <div class="col-6"><p-inputnumber #numberMax [step]="0.1" [(ngModel)]="numberRangeValue.numberrangeend"  thousandSeparator="." decimalSeparator="," [size]="8"></p-inputnumber></div>
        </div>
      </div>
    }
    @if (availableColumnToView.colType == colEnum.CheckBox) {
      <div>
        <div class="grid">
          <div class="col-6"><label style="margin-left: 15px;" for="dynlist">Prüfen auf Inhalt von</label></div>
          <div class="col-6"><p-select  optionLabel="label" id="dynlistreference" [style]="{'width': '100%'}"   appendTo="body"
            optionValue="value" showClear="true"
          [options]="referenceColumnValueNumberListOptions()" [(ngModel)]="checkBoxValue.requiredcolumnvalue" class="textinput"></p-select></div>
        </div>
        <div class="grid">
          <div class="col-6"><label style="margin-left: 15px;" for="dynlistreferenceexclude">Prüfen auf Inhalt ist NICHT gesetzt</label></div>
          <div class="col-6"><p-multiselect  optionLabel="label" id="dynlistreferenceexclude" [style]="{'width': '100%'}"   appendTo="body"
            optionValue="value" showClear="true"
          [options]="referenceNOTColumnValueNumberListOptions()" [(ngModel)]="checkBoxValue.notcolumnvalue" class="textinput"></p-multiselect></div>
        </div>
      </div>
    }
    @if (availableColumnToView.colType == colEnum.Date) {
      <div>
        <div class="grid">
          <div class="col-12"><label style="margin-left: 15px;">Keine weiteren Konfigurationsmöglichkeiten</label></div>
        </div>
      </div>
    }
    @if (availableColumnToView.colType == colEnum.ExternalValidation) {
      <div>
        <div class="grid">
          <div class="col-12"><label style="margin-left: 15px;">Derzeit nicht implementiert</label></div>
        </div>
      </div>
    }
  </div>
}
</div>


<div class="grid" style="float: right; margin-top: 20px; padding-right: 20px;">
  <button pButton type="button" icon="pi pi-times" label="Abbrechen" style="margin-left: 15px;" (click)="cancel()"></button>
  <button [disabled]="!canSave()" pButton type="button" icon="pi pi-check" label="Speichern" style="margin-left: 15px;" (click)="close()"></button>
</div>
